import React, { useState, useEffect, useRef, useMemo } from "react";
import PmMappingPanel from '../../components/PlanManagement/PmMappingPanel';
import ModuleNav, { MODULE_NAVS } from '../../components/ModuleNav';
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams, useLocation } from "react-router-dom"
import { Select, Button, Input, Spin, message, Row, Col, Segmented, Empty, Avatar, Badge, Modal, Upload, notification, Divider, Typography, Alert } from 'antd';
import Draggable from 'react-draggable';
import { SendOutlined, CheckOutlined, FileTextOutlined, BankOutlined, PhoneOutlined, MailOutlined, EnvironmentOutlined, DownloadOutlined, InboxOutlined } from '@ant-design/icons';
import { RiHospitalFill } from "react-icons/ri";
import PageTitleHook from "../pagetitle";
import debounce from 'lodash/debounce';
import { uri, uri_img } from "../../assets/utils/http-request";
import CurrencyFormat from 'react-currency-format';

import '../../styles/main.scss';
import { useAuth } from "../../assets/utils/useAuth";
import { usePermissions } from "../../assets/utils/usePermissions";
import {
  ENCOUNTER_FILE_CLAIM_PERMISSIONS,
  LEGACY_FILE_CLAIM_ROLES,
} from "../checkins/encounterPermissions";
import { hasPopulatedPermissionMap } from "../../assets/utils/permissions";
import { ALL_LEGACY_STAFF_ROLE_IDS } from "../../assets/utils/accessCatalog";
import config from "../../assets/utils/config";
import { paLineItemName } from "../preauth/paDisplayUtils";
import { selectclient } from '../../stores/verify';
import Helpers from "../../assets/utils/Helpers";
import { myRequest, myRequestObj } from "../../assets/utils/lib";
import Loader from "../compoinents/loader";
import { setupMain } from "@testing-library/user-event/dist/cjs/setup/setup.js";
import ClaimsAdminNewHook from './ClaimsAdminNewHook';
import ClaimsListHookPayment from './ClaimsListHookPayment';
import ClaimsBatchingPage from '../../components/Claims/Batches/ClaimsBatchingPage';
import AdminClaimsHierarchy from '../../components/Claims/Admin/AdminClaimsHierarchy';
import PaymentHierarchy from '../../components/Claims/Payment/PaymentHierarchy';
import ClaimsExportsDrawer from '../../components/Claims/ClaimsExportsDrawer';
import FacilityEncounterSummary from '../../components/Claims/Analytics/FacilityEncounterSummary';
import ClaimsArchiveScopeBar from '../../components/Claims/ClaimsArchiveScopeBar';
import ArchiveClaimsModal from '../../components/Claims/ArchiveClaimsModal';
import {
  canManageClaimsArchive,
  getClaimsArchiveScope,
  normalizeClaimsSegment,
} from '../../components/Claims/claimsArchiveHelpers';
import './claims-dashboard.css';

const CLAIMS_RETURN_URL_KEY = 'claims_facility_summary_return_url';

const { TextArea } = Input;
const NullSafe = (data) => {
  return data?.map(c => {
    const this_dat = {};
    Object.entries(c).forEach(col => {
      this_dat[col[0]] = col[1] || '';
    })
    return this_dat;
  })
}

export const ClaimsRequestHook = () => {
  // /file-encounter is a ProtectedRoute on the preauth module, which is wider
  // than what Send actually needs — legacy.php?claimLog is gated separately.
  // Without this, preauth.read could compose an entire claim and only find out
  // at Send. Mirrors LegacyAdminActionGate::ACTION_FILE_ENCOUNTER_CLAIM.
  const { hasAnyPermissionWithLegacy } = usePermissions();
  const canFile = hasAnyPermissionWithLegacy(
    ENCOUNTER_FILE_CLAIM_PERMISSIONS,
    LEGACY_FILE_CLAIM_ROLES,
  );
  const [items, setItems] = useState([]);
  const [complaint, setCompaint] = useState('');
  const [diagenosis, setDiagnosis] = useState([]);
  const [diagData, setDiagData] = useState([]);
  const [provDiagenosis, setProvDiagenosis] = useState([]);
  const [value, setValue] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigator = useNavigate();
  const params = new URLSearchParams(window.location.search);

  useEffect(() => {
    fetchPAData(params.get('checkin')).then(res => {
      setItems(res.items)
    });
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchDiagnosisList(username) {
    return myRequestObj('diagnosisList').post({ search: username })
      .then((response) => response?.data)
      .then((body) => {
        setDiagnosis(body.data);
        return body.data.map((user) => ({
          label: `${user.code} ${user.name}`,
          value: user.id,
        }));
      });
  }

  async function fetchPAData(claimsId) {
    return myRequestObj(`?paList`).post({ checkinId: claimsId })
      .then((response) => response?.data)
      .then((body) => {
        const provList = body?.data?.diagnosis?.map((d) => ({
          label: `${d.code} ${d.name}`,
          value: d.id,
        }))
        setProvDiagenosis(provList)
        return body?.data;
      });
  }

  const addDiagnosis = e => {
    const nn = e.map(i => {
      return diagenosis.find(j => j.id === i.value)
    })
    setDiagData(nn);
    setValue(e);
  }

  const send_claim = async () => {
    if (!canFile) return;
    setLoading(true);
    const key = 'key';
    notification.info({ message: 'Sending PA Data', key: key, duration: 3 });
    const claimData = { complaint: complaint, diagnosis: diagData, checkinId: params.get('checkin') };
    myRequestObj(`claimLog`).post(claimData)
      .then((response) => response?.data)
      .then((body) => {
        if (body?.error) {
          message.error({ content: body?.message, key: key, duration: 2 })
        } else {
          message.success({ content: body?.message, key: key, duration: 3 });
          setValue([]);
          navigator('/checkins')
        }
      });
    setLoading(false);
  }

  return (
    <>
      <PageTitleHook title="Compose Claim Request" style={{ fontSize: '1.6em', color: '#0f172a' }} />
      <hr />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginTop: '10px', marginBottom: '10px' }}>
        <div className='form-group' style={{ width: '100%', marginBottom: '5px' }}>
          <label className='form-label'>Presenting Complaints</label>
          <TextArea rows={3} style={{ width: '100%' }} onChange={e => setCompaint(e.target.value)} />
        </div>
        <div className='form-group' style={{ width: '100%', marginTop: '5px', marginBottom: '5px' }} >
          <label className='form-label'>Diagnosis - Final</label>
          <DebounceSelect
            mode="multiple"
            value={value}
            placeholder="Select Final Diagnosis"
            fetchOptions={fetchDiagnosisList}
            onChange={addDiagnosis}
            style={{ width: '100%' }}
          />
        </div>
      </div>
      <hr />
      <div style={{ maxHeight: '450px', overflowY: 'auto' }}>
        <label className='form-label'>Diagnosis - Provisional</label>
        <Select
          mode="multiple"
          value={provDiagenosis}
          style={{ width: '100%' }}
          disabled
        >
        </Select>
      </div>

      <PmMappingPanel checkinCode={params.get('checkin')} source="claims" />

      <div style={{ marginTop: 10 }}>
        <table className="table align-middle mb-0 bg-white" >
          <thead>
            <tr>
              <td>Authorization Code</td>
              <td>Requested Item</td>
              <td>Quantity</td>
              <td>Cost</td>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => {
              return (<AuthorizationRequestDataListHook data={item} index={index} />)
            })}
          </tbody>
        </table>
      </div>
      {!canFile ? (
        <Alert
          type="warning"
          showIcon
          style={{ margin: '30px' }}
          message="You cannot file this encounter"
          description="Filing an encounter's claim needs one of: encounters.checkout, claims.create or preauth.create. Ask an administrator to grant one of these to your role."
        />
      ) : null}
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', margin: '30px', justifyContent: 'flex-end', gap: '5em' }}>
        <Button onClick={send_claim} style={{ alignItems: 'center', alignContent: 'center' }} disabled={loading || !canFile}>
          {
            (loading) ?
              <Spin size="small" tip={'Sending Claim Request'} /> :
              <span>Send <SendOutlined style={{ transform: 'rotate(-30deg)' }} /></span>
          }
        </Button>
      </div>
    </>
  )
}

export const AuthorizationRequestDataListHook = props => (
  <tr>
    <td className='fw-bold'>
      <Input className="fw-normal mb-1 fw-bold" value={props.data.auth_code} disabled />
    </td>
    <td className='fw-bold'>
      <Input
        className="fw-normal mb-1 fw-bold"
        value={`${props.data.category_name.split(' ')[0]} - ${paLineItemName(props.data)}`}
        disabled
      />
    </td>
    <td>
      <Input className="fw-normal mb-1 fw-bold" value={props.data.quantity} disabled />
    </td>
    <td>
      <Input className="fw-normal mb-1 fw-bold" value={props.data.approved_cost} disabled />
    </td>
  </tr>
);

export function DebounceSelect({ fetchOptions, debounceTimeout = 1000, ...props }) {
  const [fetching, setFetching] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const fetchRef = React.useRef(0);

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      if (value.length < 3) return;
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions) => {
        console.log(newOptions);
        if (fetchId !== fetchRef.current) {
          return;
        }

        setOptions(newOptions);
        setFetching(false);
      });
    };

    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);

  return (
    <Select
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={options}
    />
  );
}

export function DebounceSelect2({
  fetchOptions,
  loadingDiagnosis,
  aborter,
  generatorOption,
  optionHandler,
  debounceTimeout = 1000,
  ...props
}) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const fetchRef = useRef(0);

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = async (value) => {
      if (!value?.length) return;

      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      options && options.length ?
        setOptions((d) => [
          { label: <Spin size="small" />, value: "_" },
          ...d.filter((i) => i.value !== "_"),
        ]) : setOptions((d) => []);

      setFetching(true);

      try {
        let fetchPromise;

        if (generatorOption) {
          fetchPromise = fetchGeneratorOptions(value);
        } else {
          fetchPromise = fetchOptions(value);
        }

        const newOptions = await fetchPromise;
        if (fetchId !== fetchRef.current) {
          // For fetch callback order
          setFetching(false);
          return;
        }
        if (newOptions?.length) setOptions((d) => [...newOptions]);
      } catch (error) {
        console.warn("Error fetching options:", error);
      } finally {
        setFetching(false);
      }
    };

    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]); //eslint-disable-line react-hooks/exhaustive-deps

  const fetchGeneratorOptions = async (value) => {
    const generator = fetchOptions(value);
    const options = [];

    for await (const items of generator) {
      if (optionHandler && typeof optionHandler === "function") {
        const opts = optionHandler(items);
        options.push(
          ...opts.filter((o) => !options.find((op) => op.value === o.value))
        );
      } else {
        options.push(...items);
      }
    }

    return options;
  };

  return (
    <Select
      labelInValue
      showSearch
      filterOption={false}
      // filterOption={(input, option) =>
      //   option && option.label && option.label.toLowerCase().includes(input.toLowerCase())
      // }
      onSearch={debounceFetcher}
      notFoundContent={
        fetching ? (
          <Spin size="small" tip="Loading ..." />
        ) : (
          <Empty
            description={<span>Empty</span>}
            style={{ padding: 50, width: "100%", height: 300 }}
          />
        )
      }
      options={options}
      {...props}
    />
  );
}

export const ClaimsListHook = props => {
  const user = JSON.parse(localStorage.getItem(config.key.user)) //eslint-disable-line
  const [claimList, setClaimsList] = useState({});
  const [claimListN, setClaimsListN] = useState({}); // eslint-disable-line
  const [filterdClaimList, setFilterdClaimsList] = useState({}); //eslint-disable-line
  const [filterKeyword, setFilterKeyword] = useState('');
  const [loading, setLoading] = useState(false); //eslint-disable-line
  const section = props.section; //eslint-disable-line
  const activeSegment = useRef("Pending CO");
  // const segmentValue = useRef(0);
  const interval = useRef();
  const fetchOperation = useRef(false);

  useEffect(() => {
    update_claims_list(activeSegment.current, true);

    // interval.current = setInterval(() => {
    //   update_claims_list(activeSegment.current, false);
    // }, 5000)

    return () => clearInterval(interval);
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    filterClaimsList(filterKeyword);
  }, [filterKeyword]) //eslint-disable-line

  async function fetchClaimsList(segment, loader = true) {
    loader && setLoading(true)
    return myRequestObj(`aClaimsListMOC`).post({ segment })
      .then((response) => response)
      .then((body) => {
        if (body?.data?.error === 'error' || Number(body?.data?.error)) {
          return {}
        } else {
          return body?.data
        }
      }).then(data => {
        return data?.data ?? {};
      }).finally(() => setLoading(false));
  }


  const handleSegmentChange = (value, claimListN) => {
    console.log(value)
    activeSegment.current = value
    setClaimsList({})
    update_claims_list(activeSegment.current, true);
    setFilterKeyword('')
  }

  const filterClaimsList = (e) => {
    // const inputValue = e
    // if(inputValue){
    //   setFilterdClaimsList(claimList.filter((val) => {
    //     return (activeSegment)? 
    //       ((
    //         val.surname.toLowerCase().indexOf(inputValue) >= 0 || val.first_name.indexOf(inputValue) >= 0 || val.claims_id.indexOf(inputValue) >= 0 
    //         || val.middle_name.toLowerCase().indexOf(inputValue) >= 0 || val.insurance_no.indexOf(inputValue) >= 0 || val.checkin_id.toLowerCase().indexOf(inputValue) >= 0 
    //         || val.claims_date.indexOf(inputValue) >= 0 || val.checkin_date.indexOf(inputValue) >= 0 || val.checkinType.toLowerCase().indexOf(inputValue) >= 0
    //         ) && (Number(val.claims_status) === activeSegment - 1)
    //       ) : 
    //       (
    //         val.surname.toLowerCase().indexOf(inputValue) >= 0 || val.first_name.toLowerCase().indexOf(inputValue) >= 0 || val.claims_id.toLowerCase().indexOf(inputValue) >= 0 
    //         || val.middle_name.toLowerCase().indexOf(inputValue) >= 0 || val.insurance_no.indexOf(inputValue) >= 0 || val.checkin_id.indexOf(inputValue) >= 0 
    //         || val.claims_date.indexOf(inputValue) >= 0 || val.checkin_date.indexOf(inputValue) >= 0 || val.checkinType.indexOf(inputValue) >= 0
    //       );
    //   }))
    // }
  }

  const update_claims_list = (segment, loader = true) => {
    if (window.location.pathname === '/claims') {
      fetchClaimsList(segment, loader).then(res => {
        // const dat = NullSafe(res)?.sort((a, b) => Date.parse(b.claims_date) - Date.parse(a.claims_date))?.sort((a, b) => Date.parse(a.claims_date) - Date.parse(b.claims_date))
        setClaimsList(res);
        // sortClaims(dat)
      });
    };
  }

  const getSegmentColor = (segment) => {
    switch (segment) {
      case "Pending CO":
        return '#121221';
      case "Pending HM":
        return '#ff9200';
      case "Pending CFO":
        return '#afaa0b';
      case "Paid":
        return '#00aa00';
      default:
        return '#121221';
    }
  };

  const getSegmentIcon = (segment) => {
    switch (segment) {
      case "Pending CO":
        return <FileTextOutlined />;
      case "Pending HM":
        return <BankOutlined />;
      case "Pending CFO":
        return <CheckOutlined />;
      case "Paid":
        return <CheckOutlined />;
      default:
        return <FileTextOutlined />;
    }
  };

  return (
    <div className="claims-container">
      {/* Modern Header */}
      <div className="claims-header">
        <h1 className="claims-title">
          <FileTextOutlined style={{ marginRight: '12px', color: '#1677ff' }} />
          Claims Management
        </h1>
        <p className="claims-subtitle">
          Review and manage facility claims with advanced filtering and real-time updates
        </p>
      </div>

      {/* Enhanced Status Segments */}
      {props.extended && (
        <div className="claims-status-segments">
          <Segmented
            block
            options={[
              {
                label: (
                  <div style={{ 
                    padding: '8px 0', 
                    justifyContent: 'center', 
                    textAlign: 'center', 
                    fontSize: '1.2em', 
                    fontWeight: 'bold',
                    color: getSegmentColor("Pending CO"),
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}>
                    {getSegmentIcon("Pending CO")}
                    Pending CO
                  </div>
                ),
                value: "Pending CO"
              },
              {
                label: (
                  <div style={{ 
                    padding: '8px 0', 
                    justifyContent: 'center', 
                    textAlign: 'center', 
                    fontSize: '1.2em', 
                    fontWeight: 'bold',
                    color: getSegmentColor("Pending HM"),
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}>
                    {getSegmentIcon("Pending HM")}
                    Pending HM
                  </div>
                ),
                value: "Pending HM"
              },
              {
                label: (
                  <div style={{ 
                    padding: '8px 0', 
                    justifyContent: 'center', 
                    textAlign: 'center', 
                    fontSize: '1.2em', 
                    fontWeight: 'bold',
                    color: getSegmentColor("Pending CFO"),
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}>
                    {getSegmentIcon("Pending CFO")}
                    Pending CFO
                  </div>
                ),
                value: "Pending CFO"
              },
              {
                label: (
                  <div style={{ 
                    padding: '8px 0', 
                    justifyContent: 'center', 
                    textAlign: 'center', 
                    fontSize: '1.2em', 
                    fontWeight: 'bold',
                    color: getSegmentColor("Paid"),
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}>
                    {getSegmentIcon("Paid")}
                    Paid
                  </div>
                ),
                value: "Paid"
              }
            ]}
            onChange={e => handleSegmentChange(e, claimListN)}
            style={{ userSelect: 'none' }}
          />
        </div>
      )}

      {/* Claims Content */}
      <div style={{ marginTop: 10 }}>
        {loading && <Loader />}
        {
          !Object.keys(claimList)?.length && !loading ?
            <div className="claims-empty-state">
              <div className="empty-icon">
                <FileTextOutlined />
              </div>
              <h3 className="empty-title">No Claims Found</h3>
              <p className="empty-description">
                There are no claims in the "{activeSegment.current}" category at the moment.
              </p>
            </div> :
            <>
              {loading ? <Loader /> : <ClaimItemHandler claim={claimList} segment={activeSegment.current} extended={props.extended} />}
            </>
        }
      </div>
    </div>
  )
}

export const ClaimItemHandler = ({ claim, segment, extended }) => {
  const navigate = useNavigate();
  const [selectedFacility,] = useState(null);
  const [targetFacility,] = useState(null);
  const [loading,] = useState(false);
  const interval = useRef();

  const handleClick = (facilityId) => {
    navigate(`/claims/filings/${btoa(facilityId)}/${btoa(segment)}`, { state: { segment, facilityId } });
  };

  useEffect(() => {
    return clearInterval(interval.current);
  }, []);

  return (
    <div className="facility-cards-grid">
      {claim.map((facility) => (
        <div
          key={facility.facility_id}
          className="facility-card"
          onClick={() => handleClick(facility.facility_id)}
        >
          <div className="facility-card-content">
            {/* Facility Information */}
            <div className="facility-info">
              <div className="facility-detail-group">
                <div className="facility-detail-label">
                  <BankOutlined style={{ marginRight: '6px' }} />
                  Facility Name
                </div>
                <div className="facility-detail-value highlight">
                  {facility.facility_name}
                </div>
              </div>

              <div className="facility-detail-group">
                <div className="facility-detail-label">
                  <EnvironmentOutlined style={{ marginRight: '6px' }} />
                  Location
                </div>
                <div className="facility-detail-value">
                  {facility.facility_state} / {facility.facility_city}
                </div>
              </div>

              <div className="facility-detail-group">
                <div className="facility-detail-label">
                  <MailOutlined style={{ marginRight: '6px' }} />
                  Email
                </div>
                <div className="facility-detail-value">
                  {facility.facility_email}
                </div>
              </div>

              <div className="facility-detail-group">
                <div className="facility-detail-label">
                  <PhoneOutlined style={{ marginRight: '6px' }} />
                  Phone
                </div>
                <div className="facility-detail-value">
                  {facility.facility_phone}
                </div>
              </div>
            </div>

            {/* Facility Statistics */}
            <div className="facility-stats">
              <div className="stat-item">
                <span className="stat-label">Claims Count</span>
                <span className="stat-value">{facility.claims_count || 0}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Total Amount</span>
                <span className="stat-value">
                  <CurrencyFormat
                    value={facility.total_amount || 0}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'₦'}
                    decimalScale={2}
                  />
                </span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Status</span>
                <span className="stat-value">{segment}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

// ClaimsListHookPayment has been moved to its own file: ClaimsListHookPayment.js

export const AuthorizationRequestDataListHookPayment = props => {
  const [, setSending] = useState(false);
  const [, setVisibleQuery] = useState(false);
  const [visibleReject,] = useState(false);
  const [visibleApproval, setVisibleApproval] = useState(false);
  const [comment, setComment] = useState('');
  const [, setProcessed] = useState(false);
  const [, setProcessing] = useState(false);
  var claimData = { ...props.data };

  // Modal control start
  const [disabled, setDisabled] = useState(false);

  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });

  const draggleRef = useRef(null);

  async function submitAction() {
    return myRequestObj(`claimItemApprove`).post(claimData)
      .then((response) => response?.data)
  }

  const handleOkReject = () => {
    setProcessing(true);
    claimData.claim_flag = 1;
    claimData.claim_comment = comment;
    submitAction();
    setSending(true);
    setVisibleApproval(false);
    setProcessing(false);
    setProcessed(true);
  }

  const handleOkApprove = e => {
    setProcessing(true);
    claimData.claim_flag = 1;
    claimData.claim_comment = comment;
    submitAction();
    setSending(true);
    setVisibleApproval(false);
    setProcessing(false);
    setProcessed(true);
  }

  const handleCancel = (e) => {
    setVisibleApproval(false);
    setVisibleQuery(false);
  };

  const onStart = (_event, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();

    if (!targetRect) {
      return;
    }

    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  return (
    <>
      <tr>
        <td>
          <Input value={props.data.auth_code} title={props.data.auth_code} disabled />
        </td>
        <td>
          <Input
            value={`${props.data.category_name.split(' ')[0]} - ${paLineItemName(props.data)}`}
            title={`${props.data.category_name.split(' ')[0]} - ${paLineItemName(props.data)}`}
            disabled
          />
        </td>
        <td>
          <Input style={{ width: 100 }} value={props.data.quantity} title={props.data.quantity} disabled />
        </td>
        <td>
          <Input style={{ width: 100 }} value={props.data.cost} title={props.data.cost} disabled />
        </td>
        <td>
          <Input style={{ width: 100 }} value={props.data.approved_cost} title={props.data.approved_cost} disabled />
        </td>
        {/* <td>
          <span style={{display: 'flex', gap: '5px 5px'}}>
            <Button type="primary" disabled={(props.data.auth_code && (!processed && !processing) && (props.data.claim_flag != 1 ))? false: true} onClick={showApprovalComment}>
              Approve 
            </Button>
            <PAQuery data = {props.data} disabled={(props.data.auth_code && (!processed && !processing)  && (props.data.claim_flag != 1 && props.data.claim_flag < 2))? false: true} />
            <Button type="primary" danger disabled={(props.data.auth_code && (!processed && !processing)  && (props.data.claim_flag != 1 && props.data.claim_flag < 2))? false: true} onClick={showRejectComment}>
              Reject
            </Button>
          </span>
        </td> */}

        <Modal
          title={
            <div
              style={{
                width: '100%',
                cursor: 'move',
              }}
              onMouseOver={() => {
                if (disabled) {
                  setDisabled(false);
                }
              }}
              onMouseOut={() => {
                setDisabled(true);
              }}
              onFocus={() => { }}
              onBlur={() => { }} // end
            >
              Approval Memo
            </div>
          }
          open={visibleApproval}
          onOk={handleOkApprove}
          onCancel={handleCancel}
          destroyOnClose
          modalRender={(modal) => (
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>
          )}
          okText={'Approve'}
        >
          <div className='form-group' style={{ width: '100%', marginBottom: '5px' }}>
            <label className='form-label'>Comment</label>
            <TextArea rows={3} style={{ width: '100%' }} onChange={(e) => setComment(e.target.value)} />
          </div>
        </Modal>

        <Modal
          title={
            <div
              style={{
                width: '100%',
                cursor: 'move',
              }}
              onMouseOver={() => {
                if (disabled) {
                  setDisabled(false);
                }
              }}
              onMouseOut={() => {
                setDisabled(true);
              }}
              onFocus={() => { }}
              onBlur={() => { }} // end
            >
              Rejection Memo
            </div>
          }
          open={visibleReject}
          onOk={handleOkReject}
          onCancel={handleCancel}
          destroyOnClose
          modalRender={(modal) => (
            <Draggable
              disabled={disabled}
              bounds={bounds}
              onStart={(event, uiData) => onStart(event, uiData)}
            >
              <div ref={draggleRef}>{modal}</div>
            </Draggable>
          )}
          okText={'Reject'}
        >
          <div className='form-group' style={{ width: '100%', marginBottom: '5px' }}>
            <label className='form-label'>Comment</label>
            <TextArea rows={3} style={{ width: '100%' }} onChange={(e) => setComment(e.target.value)} />
          </div>
        </Modal>
      </tr>
    </>
  )
}

const ClaimsHook = (props) => {
  const extended = props.extended !== undefined ? props.extended : true;
  const section = props.section !== undefined ? props.section : 'all';
  const isFacilitySummaryPage = props.page === 'facility-summary';

  const [exportDrawerOpen, setExportDrawerOpen] = useState(false);
  const [archiveModalOpen, setArchiveModalOpen] = useState(false);

  const [searchParams] = useSearchParams();
  // eslint-disable-next-line react-hooks/exhaustive-deps -- params is searchParams (stable ref from useSearchParams)
  const params = searchParams;
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const { canStayOnModule, permissions, hasAnyPermissionWithLegacy } = usePermissions();
  const dispatcher = useDispatch(selectclient);

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    if (!canStayOnModule('claims', [1, 3, 4, 5])) {
      notification.warning({
        message: 'Access Denied',
        description: "You don't have permission to access Claims Processing.",
        placement: 'topLeft'
      });
      navigate('/dashboard');
    }
  }, [user, canStayOnModule, navigate]);

  // Determine if user is a facility user (not admin/staff)
  // Facility users have rbac_user_type === 'facility' or are accessing as facility
  const isFacilityUser = user?.profile?.user?.type === 'facility' || 
                         user?.profile?.user_type === 'facility' ||
                         user?.rbac_context?.user_type === 'facility' ||
                         (user?.jwt && JSON.parse(atob(user.jwt.split('.')[1]))?.data?.rbac_user_type === 'facility');

  // Determine if the signed-in user is the payment/CFO persona: they hold claims.payment
  // and no earlier-stage claims capability. Payment users always get PaymentHierarchy
  // and cannot switch views. The negative clause is load-bearing — admin.* expands to
  // claims.payment too, and a super admin must not be locked into the payment view.
  const isPaymentUser = hasAnyPermissionWithLegacy(['claims.payment'], [5])
    && !hasAnyPermissionWithLegacy(['claims.process', 'claims.approve', 'claims.review'], [1, 3, 4]);

  // "Is this an internal staff account at all?" — an RBAC identity, or, only while the
  // permission map is still empty, any legacy staff role id.
  const isStaffUser = hasPopulatedPermissionMap(permissions, user)
    || hasAnyPermissionWithLegacy([], ALL_LEGACY_STAFF_ROLE_IDS);

  // Determine if user is admin/staff (not facility or payment).
  // Used only to suppress the facility batching UI for internal staff.
  const isAdminUser = !isFacilityUser && !isPaymentUser && isStaffUser;

  // Check if we should use new batching UI (ONLY for facility users, NEVER for admins)
  // Can be controlled by query param: ?batched=true (but only if facility user)
  const useNewBatchingUI = params.get('batched') === 'true' && isFacilityUser && !isAdminUser;

  // Get view preference from URL params
  // Payment users always use PaymentHierarchy (view param is ignored for them)
  const viewParam = isPaymentUser ? null : params.get('view'); // 'admin', 'facility', or null (default to PaymentHierarchy)
  const currentView = viewParam || 'payment';

  // Track if we've restored context on initial load
  const hasRestoredContextRef = useRef(false);

  // Restore saved context on initial load if URL params are minimal
  useEffect(() => {
    if (hasRestoredContextRef.current || isPaymentUser || params.get('checkin')) return;
    
    hasRestoredContextRef.current = true;
    
    // Check if we have minimal URL params (only view param or no navigation params)
    const hasNavigationParams = params.get('status') || params.get('month') || params.get('facility') || params.get('batch');
    
    // If no navigation params, try to restore from sessionStorage
    if (!hasNavigationParams) {
      const savedContext = sessionStorage.getItem(`claims_view_context_${currentView}`);
      if (savedContext) {
        try {
          const context = JSON.parse(savedContext);
          const newParams = new URLSearchParams(params);
          
          // Restore saved context to URL
          if (context.status) newParams.set('status', context.status);
          if (context.month) newParams.set('month', context.month);
          if (context.facility) newParams.set('facility', context.facility);
          if (context.batch) newParams.set('batch', context.batch);
          if (context.search) newParams.set('search', context.search);
          if (context.page) newParams.set('page', context.page);
          
          // Only update if params actually changed
          if (newParams.toString() !== params.toString()) {
            navigate(`/claims?${newParams.toString()}`, { replace: true });
          }
        } catch (e) {
          console.error('Error restoring view context on load:', e);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run once on mount

  // Save current view's navigation context to sessionStorage whenever it changes
  useEffect(() => {
    if (isPaymentUser || params.get('checkin')) return; // Don't save for payment users or when viewing individual claim
    
    const currentContext = {
      status: params.get('status'),
      month: params.get('month'),
      facility: params.get('facility'),
      batch: params.get('batch'),
      search: params.get('search'),
      page: params.get('page'),
    };
    
    // Save current view's context
    sessionStorage.setItem(`claims_view_context_${currentView}`, JSON.stringify(currentContext));
  }, [params, currentView, isPaymentUser]); // eslint-disable-line react-hooks/exhaustive-deps

  // Handler to switch views (only for non-payment users)
  // Preserves navigation context for each view using sessionStorage
  const handleViewChange = (newView) => {
    if (isPaymentUser) return; // Payment users cannot switch views
    
    // Save current view's navigation context before switching
    const currentContext = {
      status: params.get('status'),
      month: params.get('month'),
      facility: params.get('facility'),
      batch: params.get('batch'),
      search: params.get('search'),
      page: params.get('page'),
    };
    
    // Store current view's context in sessionStorage
    sessionStorage.setItem(`claims_view_context_${currentView}`, JSON.stringify(currentContext));
    
    // Create new params and restore target view's context
    const newParams = new URLSearchParams();
    
    // Restore target view's saved context
    const savedContext = sessionStorage.getItem(`claims_view_context_${newView}`);
    if (savedContext) {
      try {
        const context = JSON.parse(savedContext);
        if (context.status) newParams.set('status', context.status);
        if (context.month) newParams.set('month', context.month);
        if (context.facility) newParams.set('facility', context.facility);
        if (context.batch) newParams.set('batch', context.batch);
        if (context.search) newParams.set('search', context.search);
        if (context.page) newParams.set('page', context.page);
      } catch (e) {
        console.error('Error restoring view context:', e);
      }
    }
    
    // Set the view parameter
    if (newView === 'payment' || newView === null) {
      // Don't set view param for payment (it's the default)
    } else {
      newParams.set('view', newView);
    }
    
    // Preserve other params like legacy, checkin, etc.
    if (params.get('legacy')) newParams.set('legacy', params.get('legacy'));
    if (params.get('checkin')) newParams.set('checkin', params.get('checkin'));
    
    navigate(`/claims?${newParams.toString()}`, { replace: true });
  };

  const statusParam = params.get('status');
  const statusLabels = {
    '0': 'Pending CO',
    '1': 'Pending HM',
    '2': 'Pending CFO',
    '3': 'Paid',
  };
  const claimsContextLabel = statusParam != null ? statusLabels[statusParam] : null;
  // The drilldown keeps the payment stage in the URL (`?status=`), so the toolbar
  // that sits above it does know which queue the operator is standing in — pass
  // it down so Archive acts on that queue. When the URL carries no status (admin
  // months/facilities levels, legacy views), this is null and the modal says
  // "All statuses" instead of quietly sweeping every stage under a narrower label.
  const archiveSegment = normalizeClaimsSegment(statusParam);
  // The facility summary now lives under Encounters: anyone whose access lets them open
  // the route sees it. The old claims-page rule also excluded the payment persona, which
  // silently fell through to the claims view instead of the summary.
  const showFacilitySummaryActions = !isFacilityUser;
  const canArchiveClaims = canManageClaimsArchive(user, permissions);
  const archiveScope = getClaimsArchiveScope(params);
  const archiveModalMode = archiveScope === 'archived' ? 'unarchive' : 'archive';
  const lockedFacilityId = isFacilityUser
    ? (user?.facility_id ?? user?.facilityId ?? user?.profile?.facility_id ?? user?.rbac_context?.facility_id ?? null)
    : null;

  const claimsMastheadMeta = isFacilitySummaryPage
    ? 'Encounter and claims rollup by facility — active, checked out, and escalation signals'
    : claimsContextLabel
      ? `${claimsContextLabel} · navigate months, facilities, and encounters`
      : 'Review and process facility claims by payment stage';

  // Facility summary now lives under Encounters in the sidebar (/checkins/facility-summary).
  const returnToClaims = () => {
    const returnUrl = sessionStorage.getItem(CLAIMS_RETURN_URL_KEY) || '/checkins';
    sessionStorage.removeItem(CLAIMS_RETURN_URL_KEY);
    navigate(returnUrl);
  };

  return (
    <>
      {
        (user) ?
          (params.get('checkin')) ?
            <ClaimsRequestHook extended={extended} section={section} /> :
            <div className="claims-dashboard">
              <div className="dashboard-page-stack">
                <header className="dash-masthead">
                  <div className="dash-masthead__lead">
                    <h1 className="dash-masthead__title">{isFacilitySummaryPage ? 'Facility summary' : 'Claims'}</h1>
                    <p className="dash-masthead__meta">
                      {claimsMastheadMeta}
                    </p>
                  </div>
                  <div className="dash-masthead__actions claims-dashboard__toolbar">
                    {canArchiveClaims && !isFacilitySummaryPage ? (
                      <Button
                        icon={<InboxOutlined />}
                        size="small"
                        onClick={() => setArchiveModalOpen(true)}
                      >
                        {archiveModalMode === 'unarchive' ? 'Unarchive' : 'Archive'}
                      </Button>
                    ) : null}
                    {showFacilitySummaryActions && isFacilitySummaryPage ? (
                      <Button
                        icon={<BankOutlined />}
                        size="small"
                        onClick={returnToClaims}
                      >
                        Back to encounters
                      </Button>
                    ) : null}
                    <Button
                      icon={<DownloadOutlined />}
                      size="small"
                      onClick={() => setExportDrawerOpen(true)}
                    >
                      Exports
                    </Button>
                  </div>
                </header>

                {isFacilitySummaryPage ? <ModuleNav items={MODULE_NAVS.encounters} /> : null}
                {/* Claims strip (Claims processing | Pending submission). Hides
                    itself while the new flow is off — one visible entry. */}
                {!isFacilitySummaryPage && !params.get('checkin') ? (
                  <ModuleNav items={MODULE_NAVS.claims} />
                ) : null}
                {!isFacilitySummaryPage && !params.get('checkin') ? (
                  <ClaimsArchiveScopeBar />
                ) : null}

                <div className="claims-dashboard__body">
                  {isFacilitySummaryPage && showFacilitySummaryActions ? (
                    <FacilityEncounterSummary
                      embedded
                      onOpenExportsDrawer={() => setExportDrawerOpen(true)}
                    />
                  ) : viewParam === 'admin' && !isPaymentUser ? (
                    params.get('legacy') === 'true' ? (
                      <ClaimsAdminNewHook />
                    ) : (
                      <AdminClaimsHierarchy />
                    )
                  ) : (viewParam === 'facility' || useNewBatchingUI) && isFacilityUser && !isPaymentUser ? (
                    <ClaimsBatchingPage />
                  ) : params.get('legacy') === 'true' ? (
                    <ClaimsListHookPayment extended={extended} section={section} />
                  ) : (
                    <PaymentHierarchy />
                  )}
                </div>
              </div>

              <ClaimsExportsDrawer
                open={exportDrawerOpen}
                onClose={() => setExportDrawerOpen(false)}
              />
              <ArchiveClaimsModal
                open={archiveModalOpen}
                mode={archiveModalMode}
                allowPick
                // Month-wide is an internal-staff action: the API pins a
                // facility user to their own facility regardless.
                allowMonthWide={!isFacilityUser}
                lockedFacility={Boolean(isFacilityUser && lockedFacilityId)}
                segment={archiveSegment}
                initialFacilityId={lockedFacilityId || params.get('facility')}
                initialMonth={params.get('month')}
                onClose={() => setArchiveModalOpen(false)}
                onSuccess={(parsed) => {
                  setArchiveModalOpen(false);
                  const count = parsed?.archivedCount ?? parsed?.previewCount ?? 0;
                  notification.success({
                    message: archiveModalMode === 'unarchive' ? 'Claims restored' : 'Claims archived',
                    description: parsed?.message || `${count} claim${count === 1 ? '' : 's'} updated.`,
                    placement: 'topRight',
                  });
                }}
              />
            </div>
          : null
      }
    </>
  )
}

export default ClaimsHook;